import { Card, Stack } from '@optimus-web/core';
import { usePaymentDetailsSidebarContext } from '../../context/PaymentDetailsSidebarContext';
import { getPaymentDetailsEntries, renderDetailEntries, renderReceiptEntries } from './util';

export const LegacyPaymentDetailsSidebarContent = () => {
    const { paymentDetails, receipt } = usePaymentDetailsSidebarContext();

    if (!paymentDetails) {
        return null;
    }

    return (
        <Stack vertical spacing="200">
            <Card padding="200">
                <Stack vertical spacing="100">
                    {renderDetailEntries(getPaymentDetailsEntries(paymentDetails))}
                </Stack>
            </Card>
            {receipt && (
                <Card padding="200">
                    <Stack vertical spacing="200">
                        <Stack vertical spacing="100">
                            {renderReceiptEntries(receipt?.receiptData)}
                        </Stack>
                    </Stack>
                </Card>
            )}
        </Stack>
    );
};
